const filterSelector = (filterSelector) => {
    const filters = document.querySelectorAll(filterSelector);
    filters && filters.forEach(filter => inputHandler(filter));
};
const inputHandler = (filter) => {
    const title = filter.querySelector('.btn');
    if (!title) {
        return false;
    }
    const inputs = filter.querySelectorAll('input');
    if (!inputs) {
        return false;
    }
    changeStatus(inputs, title);
    inputs.forEach(input => {
        input.addEventListener('change', function () {
            this.checked && (title.dataset.filled = 'filled');
            changeStatus(inputs, title);
        });
    });
    const clearBtn = title.querySelector('.clear-filter');
    clearBtn && clearBtn.addEventListener('click', function () {
        inputs.forEach(input => {
            input.checked = false;
            input.value = '';
        });
        changeStatus(inputs, title);
    });
};
const changeStatus = (inputs, title) => {
    let state = '';
    inputs.forEach(input => {
        switch (input.type) {
            case 'text':
                if (input.value) {
                    console.log(input.value);
                    state = 'checked';
                }
                ;
                break;
            case 'checkbox':
                input.checked && (state = 'checked');
                break;
            default:
                console.log('Unexpected Input Type');
        }
    });
    state === 'checked' ? title.dataset.filled = 'filled' : title.dataset.filled = '0';
};
export default filterSelector;
